export async function PostEnquireApi(postData) {
    const settings = {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(postData),
    };

    try {
        const url = `${window.env.APIMURL}system/enquire`;
        const fetchResponse = await fetch(url, settings);

        const status = fetchResponse.status;
        const value = await fetchResponse.text();

        return { status, value };
    } catch (error) {
        return {
            status: 500,
            value: error?.message || "Internal Server Error",
        };
    }
}
